<template>
  <div class="p-3 pb-32 bg mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 text-white" id="style-1">
    <div>
      <!-- Header -->
      <header class="bg-gray-900 bg-opacity-80 p-4 border rounded mb-1 border-gray-800 shadow-xl">
        <div class="flex flex-wrap justify-between items-center gap-2 max-w-7xl mx-auto">
          <h1 class="text-xl font-semibold text-indigo-300">{{ isAdmin ? 'จัดการไอเทม' : 'รายการไอเทม' }}</h1>
          <div v-if="isAdmin" class="flex flex-wrap items-center gap-2">
            <TemplateExportButton
              collection-name="gameItems"
              file-name="gameItems.json"
              label="Export gameItems.json"
            />
            <button 
              @click="toggleModal = 'AddItemModal'" 
              class="bg-indigo-600 hover:bg-indigo-700 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              aria-label="เพิ่มไอเทมใหม่"
            >
              <i class="fas fa-plus-circle text-xs"></i> เพิ่มไอเทมใหม่
            </button>
            <button
              @click="importLatestItems"
              :disabled="isImporting"
              class="bg-emerald-600 hover:bg-emerald-700 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              aria-label="นำเข้าไอเทมใหม่"
            >
              <i class="fas fa-file-import text-xs"></i>
              {{ isImporting ? 'กำลังนำเข้า...' : 'Import ไอเทมใหม่' }}
            </button>
            <!-- Toggle View Mode -->
            <button 
              @click="viewMode = viewMode === 'cards' ? 'json' : 'cards'" 
              class="bg-gray-700 hover:bg-gray-600 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2"
              aria-label="สลับมุมมอง"
            >
              <i class="fas" :class="viewMode === 'cards' ? 'fa-code' : 'fa-th-large'"></i>
              {{ viewMode === 'cards' ? 'ดู JSON' : 'ดูการ์ด' }}
            </button>
          </div>
        </div>
      </header>

      <!-- Filters -->
      <section class="w-full">
        <div class="bg-gray-900 bg-opacity-80 p-4 border rounded mb-1 border-gray-800 shadow-xl">
          <h3 class="text-sm font-semibold text-indigo-200 mb-3">ตัวกรองไอเทม</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            <!-- Type -->
            <div>
              <label class="block text-sm font-medium text-indigo-200 mb-1">ประเภท</label>
              <select 
                v-model="filterType" 
                @change="applyFilters" 
                class="w-full px-3 py-2 bg-gray-800 text-indigo-200 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-200"
                aria-label="ประเภทไอเทม"
              >
                <option value="">ทั้งหมด</option>
                <option value="หมวก">หมวก</option>
                <option value="แว่นตา">แว่นตา</option>
                <option value="เสื้อ">เสื้อ</option>
                <option value="เสื้อคลุม">เสื้อคลุม</option>
                <option value="เกราะ">เกราะ</option>
                <option value="ปลอกแขน">ปลอกแขน</option>
                <option value="ถุงมือ">ถุงมือ</option>
                <option value="กางเกง">กางเกง</option>
                <option value="สนับแข้ง">สนับแข้ง</option>
                <option value="รองเท้า">รองเท้า</option>
                <option value="เข็มขัด">เข็มขัด</option>
                <option value="สร้อยคอ">สร้อยคอ</option>
                <option value="แหวน">แหวน</option>
                <option value="อาวุธ">อาวุธ</option>
                <option value="อาวุธสำรอง">อาวุธสำรอง</option>
                <option value="ตะกรุด">ตะกรุด</option>
                <option value="ผ้ายันต์">ผ้ายันต์</option>
                <option value="สายสิญจน์">สายสิญจน์</option>
                <option value="อวัยวะจักรกล">อวัยวะจักรกล</option>
                <option value="วิญญาณ">วิญญาณ</option>
                <option value="หนังสือ">หนังสือ</option>
                <option value="อาหาร">อาหาร</option>
                <option value="แผนที่">แผนที่</option>
                <option value="รักษา">รักษา</option>
                <option value="กัปดัก">กัปดัก</option>
                <option value="ปลดกัปดัก">ปลดกัปดัก</option>
                <option value="ระเบิด">ระเบิด</option>
                <option value="วัสดุ">วัสดุ</option>
                <option value="วัสดุสิ่งมีชีวิตกลายพันธุ์">วัสดุสิ่งมีชีวิตกลายพันธุ์</option>
                <option value="วัสดุวิญญาณ">วัสดุวิญญาณ</option>
                <option value="ไล่ผี">ไล่ผี</option>
                <option value="ทั่วไป">ทั่วไป</option>
                <option value="กล่อง">กล่อง</option>
                <option value="พาหนะ">พาหนะ</option>
                <option value="หุ่นยนต์สังหาร">หุ่นยนต์สังหาร</option>
                <option value="ปล้น">ปล้น</option>
                <option value="การ์ด">การ์ด</option>
                <option value="สิ่งมีชีวิตกลายพันธุ์">สิ่งมีชีวิตกลายพันธุ์</option>
              </select>
            </div>
            <!-- Subtype for Spirit -->
            <div v-if="filterType === 'วิญญาณ'">
              <label class="block text-sm font-medium text-indigo-200 mb-1">ประเภทย่อย</label>
              <select 
                v-model="filterSubtype" 
                @change="applyFilters" 
                class="w-full px-3 py-2 bg-gray-800 text-indigo-200 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-200"
                aria-label="ประเภทย่อยวิญญาณ"
              >
                <option value="">ทั้งหมด</option>
                <option value="วิญญาณเฝ้าห้อง">วิญญาณเฝ้าห้อง</option>
                <option value="วิญญาณค้นหาผู้เล่น">วิญญาณค้นหาผู้เล่น</option>
                <option value="วิญญาณผู้พิทักษ์">วิญญาณผู้พิทักษ์</option>
              </select>
            </div>
            <!-- Name Search -->
            <div>
              <label class="block text-sm font-medium text-indigo-200 mb-1">ค้นหาชื่อ</label>
              <input 
                v-model="searchName" 
                @input="applyFilters" 
                type="text" 
                placeholder="พิมพ์ชื่อไอเทม..." 
                class="w-full px-3 py-2 bg-gray-800 text-indigo-200 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-200"
                aria-label="ค้นหาด้วยชื่อไอเทม"
              />
            </div>
            <!-- Sort -->
            <div>
              <label class="block text-sm font-medium text-indigo-200 mb-1">จัดเรียง</label>
              <select 
                v-model="sortBy" 
                @change="applyFilters" 
                class="w-full px-3 py-2 bg-gray-800 text-indigo-200 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-200"
                aria-label="จัดเรียง"
              >
                <option value="rarity-asc">ระดับความหายาก ↑ (แบบเก่า)</option>
                <option value="rarity-desc">ระดับความหายาก ↓</option>
                <option value="name-asc">ชื่อ ก-ฮ</option>
                <option value="name-desc">ชื่อ ฮ-ก</option>
                <option value="created-asc">สร้างก่อน → หลัง</option>
                <option value="created-desc">สร้างหลัง → ก่อน</option>
              </select>
            </div>
            <!-- Rarity -->
            <div>
              <label class="block text-sm font-medium text-indigo-200 mb-1">ระดับความหายาก</label>
              <select 
                v-model="filterRarity" 
                @change="applyFilters" 
                class="w-full px-3 py-2 bg-gray-800 text-indigo-200 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-200"
                aria-label="ระดับความหายาก"
              >
                <option value="">ทั้งหมด</option>
                <option v-for="n in 20" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      <!-- Main Content -->
      <main class="max-w-7xl mx-auto">
        <!-- Error Message -->
        <div v-if="error" class="text-red-300 text-sm text-center mb-4">
          {{ error }}
        </div>

        <!-- JSON View (Admin Only) -->
        <div v-if="isAdmin && viewMode === 'json'" class="mt-4">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-sm font-semibold text-indigo-200">JSON View ({{ filteredItems.length }} items)</h3>
            <button 
              @click="copyJson" 
              class="bg-gray-700 hover:bg-gray-600 text-xs text-white py-1 px-3 rounded-md transition-colors"
            >
              <i class="fas fa-copy mr-1"></i> คัดลอก JSON
            </button>
          </div>
          <pre class="bg-gray-900 p-4 rounded-md border border-gray-700 text-xs text-indigo-200 overflow-auto max-h-[70vh]">{{ filteredItemsJson }}</pre>
        </div>

        <!-- Cards View -->
        <div v-else>
          <div v-if="displayedItems.length === 0" class="text-center text-indigo-200 py-6">
            <i class="fas fa-box-open text-2xl mb-2"></i>
            <p class="text-sm">ไม่มีไอเทมที่ตรงกับการค้นหา</p>
          </div>
          <div v-else ref="itemsGrid" class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
            <div 
              v-for="item in displayedItems" 
              :key="item.id" 
              @click="openDetailModal(item)"
              class="bg-gray-900 rounded-md p-4 border border-gray-800 bg-opacity-80 hover:bg-opacity-80 transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer shadow-xl"
            >
              <div class="relative">
                <img 
                  :src="item.img || 'default-item.png'" 
                  alt="Item Image" 
                  class="w-full h-32 object-cover rounded-md border-2"
                  :class="item.rarityColors?.borderColor || 'border-indigo-400'"
                  @error="handleImageError"
                />
                <div class="absolute top-2 right-2 bg-gray-800 bg-opacity-70 px-2 py-1 rounded-md text-xs text-indigo-200 flex items-center gap-1">
                  <i class="fas fa-star text-yellow-400"></i> {{ item.rarity }}
                </div>
              </div>
              <div class="mt-2">
                <div class="flex items-center justify-between">
                  <h3 
                    class="text-sm font-semibold truncate"
                    :class="item.rarityColors?.textColor || 'text-indigo-200'"
                  >
                    {{ item.name }}
                  </h3>
                  <i 
                    class="fas fa-copy text-xs text-indigo-200 cursor-pointer hover:text-indigo-400 transition-colors duration-200" 
                    @click.stop="copyName(item.name)"
                    aria-label="คัดลอกชื่อไอเทม"
                  ></i>
                </div>
                <p v-if="item.type === 'การ์ด'" class="text-xs text-indigo-200 mb-2">ติดตั้ง {{ item.compatibleEquipment }}</p>
                <p v-if="item.type === 'วิญญาณ'" class="text-xs text-indigo-200 mb-2">ประเภทย่อย: {{ item.subtype }}</p>
                <div class="space-y-1 text-xs text-indigo-200">
                  <p v-if="item.type && !['ทั่วไป', 'หนังสือ', 'อาหาร'].includes(item.type)" class="flex items-center gap-1">
                    <i class="fas fa-star text-indigo-400"></i> เลเวลขั้นต่ำ {{ item.requiredLevel || 0 }}
                  </p>
                  <p class="flex items-center gap-1">
                    <i class="fas fa-weight-hanging text-indigo-400"></i> {{ item.weight || 0 }}
                  </p>
                  <p class="flex items-center gap-1">
                    <i v-if="item.currencyType === 'gold'" class="fa-solid fa-g text-yellow-400"></i>
                    <i v-else-if="item.currencyType === 'diamond'" class="fa-solid fa-gem text-blue-400"></i>
                    <i v-else class="fa-solid fa-coins text-gray-100"></i>
                    {{ (item.price || 0).toLocaleString() }}
                  </p>
                </div>
              </div>
              <div v-if="isAdmin" class="mt-2 pt-2 border-t border-gray-600">
                <button 
                  @click.stop="openEditModal(item)" 
                  class="w-full bg-indigo-600 hover:bg-indigo-700 text-sm text-white py-1 px-2 rounded-md transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                  aria-label="แก้ไขไอเทม"
                >
                  <i class="fas fa-edit text-xs"></i> แก้ไข
                </button>
              </div>
            </div>
          </div>

          <!-- Load More Button -->
          <div class="mt-6 flex justify-center">
            <button 
              v-if="hasMore" 
              @click="loadMore" 
              class="bg-indigo-600 hover:bg-indigo-700 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              aria-label="โหลดเพิ่มเติม"
            >
              <i class="fas fa-arrow-down text-xs"></i> โหลดเพิ่มเติม
            </button>
            <span v-if="!hasMore && displayedItems.length > 0" class="text-indigo-200 text-sm">ไม่มีไอเทมเพิ่มเติมแล้ว ({{ displayedItems.length }} รายการ)</span>
          </div>
        </div>
      </main>

      <!-- Modal -->
      <AddItemModal v-if="isAdmin && toggleModal === 'AddItemModal'" @cancelModal="toggleModal = ''" @itemAdded="resetAndFetch" />
      <DetailItemModal v-if="toggleModal === 'DetailItemModal'" :item="selectedItem" @close="toggleModal = ''" />
      <EditItemModal v-if="isAdmin && toggleModal === 'EditItemModal'" :item="selectedItem" @cancelModal="toggleModal = ''" />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import { usePlayerStore } from '@/composables/usePlayerStore';
import AddItemModal from '../components/admin/AddItemModal.vue';
import EditItemModal from '../components/admin/EditItemModal.vue';
import DetailItemModal from '../components/admin/DetailItemModal.vue';
import TemplateExportButton from '../components/admin/TemplateExportButton.vue';
import { projectFirestore } from '@/firebase/config';
import getUser from '@/composables/getUser';
import gameItemsData from '@/data/gameItems.json';

export default {
  components: { AddItemModal, EditItemModal, DetailItemModal, TemplateExportButton },
  setup() {
    const toggleModal = ref('');
    const filterType = ref('');
    const filterSubtype = ref('');
    const filterRarity = ref('');
    const searchName = ref('');
    const sortBy = ref('rarity-asc');
    const viewMode = ref('cards');
    const selectedItem = ref(null);
    const isLoading = ref(false);
    const isImporting = ref(false);
    const isAdmin = ref(false);
    const error = ref('');
    const itemsPerLoad = 24;
    const loadedCount = ref(itemsPerLoad);
    const itemsGrid = ref(null);

    const { user } = getUser();

    // All items from JSON
    const allItems = Object.entries(gameItemsData).map(([name, data]) => ({
      id: name,
      name,
      ...data,
      rarityColors: data.rarityColors || {
        bgColor: 'bg-gray-700',
        textColor: 'text-indigo-200',
        borderColor: 'border-indigo-400'
      }
    }));

    // Filtered & sorted items
    const filteredItems = computed(() => {
      let result = [...allItems];

      // Type filter
      if (filterType.value) {
        result = result.filter(item => item.type === filterType.value);
      }
      // Subtype filter
      if (filterType.value === 'วิญญาณ' && filterSubtype.value) {
        result = result.filter(item => item.subtype === filterSubtype.value);
      }
      // Name search (real-time)
      if (searchName.value.trim()) {
        const q = searchName.value.trim().toLowerCase();
        result = result.filter(item => item.name.toLowerCase().includes(q));
      }
      // Rarity filter
      if (filterRarity.value) {
        result = result.filter(item => item.rarity === Number(filterRarity.value));
      }

      // Sort
      switch (sortBy.value) {
        case 'rarity-asc':
          result.sort((a, b) => {
            if (a.rarity !== b.rarity) return (a.rarity || 0) - (b.rarity || 0);
            return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
          });
          break;
        case 'rarity-desc':
          result.sort((a, b) => (b.rarity || 0) - (a.rarity || 0));
          break;
        case 'name-asc':
          result.sort((a, b) => a.name.localeCompare(b.name, 'th'));
          break;
        case 'name-desc':
          result.sort((a, b) => b.name.localeCompare(a.name, 'th'));
          break;
        case 'created-asc':
          result.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
          break;
        case 'created-desc':
          result.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
          break;
      }

      return result;
    });

    // Pagination
    const displayedItems = computed(() => filteredItems.value.slice(0, loadedCount.value));
    const hasMore = computed(() => displayedItems.value.length < filteredItems.value.length);

    // JSON view
    const filteredItemsJson = computed(() => JSON.stringify(filteredItems.value, null, 2));

    const applyFilters = () => {
      loadedCount.value = itemsPerLoad;
    };

    const loadMore = () => {
      loadedCount.value += itemsPerLoad;
    };

    const playerStore = usePlayerStore();

    watch(() => playerStore.userData, (data) => {
      if (data) {
        isAdmin.value = data.admin === true;
      } else {
        isAdmin.value = false;
      }
    }, { immediate: true });

    const handleImageError = (event) => {
      event.target.src = 'default-item.png';
    };

    const openEditModal = (item) => {
      selectedItem.value = item;
      toggleModal.value = 'EditItemModal';
    };

    const openDetailModal = (item) => {
      selectedItem.value = item;
      toggleModal.value = 'DetailItemModal';
    };

    const copyName = (name) => {
      navigator.clipboard.writeText(name)
        .catch(err => {
          console.error('Failed to copy name:', err);
          alert('เกิดข้อผิดพลาดในการคัดลอกชื่อไอเทม');
        });
    };

    const copyJson = () => {
      navigator.clipboard.writeText(filteredItemsJson.value)
        .catch(err => {
          console.error('Failed to copy JSON:', err);
          alert('เกิดข้อผิดพลาดในการคัดลอก JSON');
        });
    };

    const resetAndFetch = () => {
      applyFilters();
    };

    const importLatestItems = async () => {
      if (!confirm('ต้องการนำเข้าไอเทมใหม่ล่าสุดลง Firestore ใช่หรือไม่?')) return;
      isImporting.value = true;
      error.value = '';
      try {
        // Find items with the latest createdAt date
        const cutoffDate = '2026-05-24';
        const latestItems = Object.entries(gameItemsData).filter(([_, item]) => {
          return item.createdAt && item.createdAt.startsWith(cutoffDate);
        });

        if (latestItems.length === 0) {
          alert('ไม่พบไอเทมใหม่ที่ต้องการนำเข้า');
          isImporting.value = false;
          return;
        }

        let importedCount = 0;
        for (const [name, data] of latestItems) {
          const importData = { ...data };
          // Convert createdAt string to Date object for Firestore Timestamp
          if (typeof importData.createdAt === 'string') {
            importData.createdAt = new Date(importData.createdAt);
          } else if (!importData.createdAt) {
            importData.createdAt = new Date();
          }
          await projectFirestore.collection('gameItems').doc(name).set(importData);
          importedCount++;
        }
        alert(`นำเข้าไอเทมใหม่สำเร็จ ${importedCount} รายการ`);
      } catch (err) {
        console.error('Import items error:', err);
        error.value = 'เกิดข้อผิดพลาดในการนำเข้าไอเทม: ' + err.message;
        alert(error.value);
      } finally {
        isImporting.value = false;
      }
    };

    onMounted(() => {
      // admin status is now reactive via store watch
    });

    return { 
      toggleModal, 
      filterType, 
      filterSubtype,
      filterRarity, 
      searchName,
      sortBy,
      viewMode,
      displayedItems,
      filteredItemsJson,
      filteredItems,
      selectedItem, 
      openEditModal, 
      openDetailModal, 
      loadMore,
      hasMore,
      isLoading,
      isImporting,
      isAdmin,
      resetAndFetch,
      applyFilters,
      importLatestItems,
      error,
      handleImageError,
      itemsGrid,
      copyName,
      copyJson
    };
  },
};
</script>

<style scoped>
.min-h-screen {
  min-height: 100vh;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #374151;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

/* Animations */
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

button:disabled, input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

button:not(:disabled):active {
  transform: scale(0.98);
}
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fcondo.png?alt=media&token=198ebb1c-66e5-4bf0-aa79-32bff287aa09') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
  background-size: cover;
}
</style>
